export default [
  {
    label: 'File',
    value: 'file',
  },
  {
    label: 'Web Url',
    value: 'url',
  },
  {
    label: 'Vimeo',
    value: 'vimeo',
  },
];
